module.exports = __webpack_public_path__ + "60bd861f0e3f048636170ff787ffcc77.svg";